export default {
  text: 'Loading. Please wait.',
};
